<template>
  <section class="product-one">
    <div class="container">
      <h3 class="product-one__title title-red" :class="{ 'es-py-underline': locale === 'es-PY' }">
        {{ t('productSection.title') }}
      </h3>

      <div class="container-carousel">
        <div id="productCarousel" class="carousel slide" data-bs-ride="carousel">
          <div class="carousel-inner">
            <!-- SKELETON -->
            <div class="carousel-item active" v-if="isLoading">
              <div class="flex-row-wrap">
                <div v-for="n in itemsPerPage" :key="n" class="product__item skeleton-loader">
                  <div class="skeleton-box skeleton-img"></div>
                  <div class="skeleton-box skeleton-text" style="height: 20px; width: 80%; margin: 8px auto 0;"></div>
                  <div class="skeleton-box skeleton-text" style="height: 20px; width: 60%; margin: 6px auto;"></div>
                </div>
              </div>
            </div>

            <!-- PRODUTOS REAIS -->
            <div class="carousel-item" :class="{ active: index === 0 }" v-else
              v-for="(productChunk, index) in chunkedProducts" :key="index">
              <div class="flex-row-wrap">
                <ProductCard v-for="item in productChunk" :key="item.id" :product="item" :current-page="1"
                  class="product__item" />
              </div>
            </div>
          </div>

          <!-- Botões de navegação -->
          <button class="carousel-control-prev custom-carousel-control" type="button" data-bs-target="#productCarousel"
            data-bs-slide="prev" v-if="!isLoading">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ t('productSection.previous') }}</span>
          </button>
          <button class="carousel-control-next custom-carousel-control" type="button" data-bs-target="#productCarousel"
            data-bs-slide="next" v-if="!isLoading">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ t('productSection.next') }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import ProductCard from '../produtos/productCard.vue';
import { fetchProducts } from '@/services/apiService';

export default {
  name: 'ProductSection',
  components: {
    ProductCard
  },
  setup() {
    const { t, locale } = useI18n();

    const products = ref([]);
    const chunkedProducts = ref([]);
    const itemsPerPage = ref(5);
    const isLoading = ref(true);

    const chunkArray = (array, chunkSize) => {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    };

    const fetchProductList = async () => {
      isLoading.value = true;
      try {
        const params = {
          text: '',
          category_id: 13,
          department_id: 5,
          page: 1,
          order_by: 'tem_estoque,id',
          order: 'desc,desc'
        };

        const data = await fetchProducts(params);
        products.value = data.data || [];
        chunkedProducts.value = chunkArray(products.value, itemsPerPage.value);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const updateChunkedProducts = () => {
      const width = window.innerWidth;
      if (width < 576) {
        itemsPerPage.value = 2;
      } else if (width < 768) {
        itemsPerPage.value = 2;
      } else if (width < 992) {
        itemsPerPage.value = 3;
      } else if (width < 1200) {
        itemsPerPage.value = 4;
      } else {
        itemsPerPage.value = 5;
      }
      chunkedProducts.value = chunkArray(products.value, itemsPerPage.value);
    };

    onMounted(() => {
      fetchProductList();
      updateChunkedProducts();
      window.addEventListener('resize', updateChunkedProducts);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateChunkedProducts);
    });

    return {
      t,
      locale,
      products,
      chunkedProducts,
      itemsPerPage,
      isLoading
    };
  },
};
</script>

<style scoped>
/* estilos existentes */
.title-red {
  color: rgba(226, 59, 51, 0.8);
  margin-bottom: 40px;
  font-size: 2.3rem;
  max-width: 1170px;
  margin: 0 auto;
}

.container-carousel {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.carousel {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
}

.product-one__title::after {
  position: absolute;
  right: 1px;
  top: 0;
  bottom: 0;
  margin: auto;
  width: calc(100% - 180px);
  height: 2px;
  content: "";
  background-color: var(--karoons-border-color, #DEDEDE);
}

.product-one__title.es-py-underline::after {
  width: calc(100% - 200px);
}

.flex-row-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 0 10px;
}

.custom-carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #E23B33;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.9;
  z-index: 20;
  pointer-events: all;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 12px;
  height: 12px;
  background-size: 12px 12px;
}

.carousel-control-prev {
  left: -60px;
}

.carousel-control-next {
  right: -60px;
}

@media (max-width: 768px) {
  .carousel-control-prev {
    left: -40px;
  }

  .carousel-control-next {
    right: -40px;
  }
}

@media (max-width: 576px) {
  .carousel-control-prev {
    left: -12px;
  }

  .carousel-control-next {
    right: -12px;
  }
}

.product__item {
  display: flex;
  flex-direction: column;
  max-width: 250px;
  margin-bottom: 20px;
}

@media (min-width: 1250px) {
  .product__item {
    width: calc(20% - 20px);
  }
}

@media (max-width: 1200px) {
  .product__item {
    width: calc(25% - 20px);
  }
}

@media (max-width: 992px) {
  .product__item {
    width: calc(33.33% - 20px);
  }
}

@media (max-width: 768px) {
  .product__item {
    width: calc(50% - 20px);
  }
}

@media (max-width: 576px) {
  .product__item {
    width: 45%;
  }
}

.skeleton-loader {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  box-sizing: border-box;
}

.skeleton-box {
  background-color: #ddd;
  border-radius: 6px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-img {
  width: 100%;
  height: 180px;
}

.skeleton-text {
  background-color: #e0e0e0;
}

@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }

  50% {
    background-color: #f2f2f2;
  }

  100% {
    background-color: #e0e0e0;
  }
}
</style>
